const MobileProductSkeleton = () => (
  <div className="block md:hidden">
    <div className="bg-white border border-slate-200 rounded-xl mx-4 my-3 overflow-hidden">
      <div className="p-6">
        {/* Header section skeleton */}
        <div className="flex items-start justify-between mb-5">
          <div className="flex-1 min-w-0">
            <div className="h-5 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse mb-3"></div>
            <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse w-3/4"></div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <div className="w-20 h-7 bg-gradient-to-r from-slate-200 to-slate-100 rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Stats section skeleton */}
        <div className="grid grid-cols-2 gap-4 mb-5">
          <div className="bg-slate-50 rounded-lg p-3">
            <div className="flex items-center">
              <div className="w-4 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mr-2"></div>
              <div className="flex-1">
                <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse w-12 mb-1"></div>
                <div className="h-3 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse w-16"></div>
              </div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-3">
            <div className="flex items-center">
              <div className="w-4 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mr-2"></div>
              <div className="flex-1">
                <div className="h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse w-12 mb-1"></div>
                <div className="h-3 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse w-20"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer skeleton */}
        <div className="flex items-center justify-between pt-4 border-t border-slate-100">
          <div className="flex items-center">
            <div className="w-4 h-4 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse mr-2"></div>
            <div className="h-3 bg-gradient-to-r from-slate-200 to-slate-100 rounded animate-pulse w-20"></div>
          </div>
          <div className="w-28 h-9 bg-gradient-to-r from-slate-200 to-slate-100 rounded-lg animate-pulse"></div>
        </div>
      </div>
    </div>
  </div>
);


export default MobileProductSkeleton;